import { render, staticRenderFns } from "./MailToReadForm.vue?vue&type=template&id=1294d4e8&"
import script from "./MailToReadForm.vue?vue&type=script&lang=js&"
export * from "./MailToReadForm.vue?vue&type=script&lang=js&"
import style0 from "./MailToReadForm.vue?vue&type=style&index=0&id=1294d4e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports